<template>
  <div class="grid-item-component"
       :class="[
         `grid-item--${size}`,
       ]"
  >
    <ym-img v-if="size === 'small'"
            class="grid-item-cover"
            :radius="4"
            :src="item.cover"
            :alt="item.title"
    />
    <div v-else
         class="grid-item-cover-container"
    >
      <ym-img class="grid-item-cover"
              :radius="4"
              :src="item.cover"
              :alt="item.title"
      />
      <mark-text v-if="mark"
                 :type="mark.type"
                 :text="markText"
      />
      <product-target v-if="target && target.icon"
                      :target="target"
      />
    </div>
    <div class="grid-item-bottom">
      <div class="grid-item-info">
        <h3 v-if="showTitle && item.title !== ''"
            class="grid-item-title ym-two-line-ellipsis"
        >
          <i v-if="item.isVipProduct"
             class='list-item-vip-icon'
          ></i>{{ item.title }}
        </h3>
        <span v-if="showSummary && item.summary !== ''"
              class="grid-item-summary ym-two-line-ellipsis"
        >{{ item.summary }}</span>
        <product-tags v-if="size !== 'small' && tags && tags.length !== 0"
                      :tags="tags"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import MarkText from '@/components/ProductMarkText';
  import ProductTarget from '@/components/ProductTarget';
  import ProductTags from '@/components/ProductTags';

  export default {
    name: 'ProductGridItem',
    components: {
      MarkText,
      ProductTarget,
      ProductTags,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      size: {
        type: String,
        validator(val) {
          return [
            'small',
            'large',
            'full',
            'card',
          ].includes(val);
        },
        default: 'small',
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
      showSummary: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      mark() {
        const { item } = this;
        const { render } = item;
        if (!render) return null;
        return render.mark;
      },
      markText() {
        const { mark } = this;
        if (mark == null) return '';
        return mark.text;
      },
      target() {
        const { item } = this;
        const { target } = item;
        if (typeof target !== 'object') return null;
        return target;
      },
      tags() {
        const { item } = this;
        const { render } = item;
        if (!render) return null;
        return render.tags;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  @grid-item-card-width: 320px;
  @grid-item-card-cover-height: 240px;

  @grid-item-small-width: 280px;
  @grid-item-small-cover-height: 156px;

  @grid-item-large-width: 610px;
  @grid-item-large-cover-height: 344px;

  @grid-item-full-width: 690px;
  @grid-item-full-cover-height: 258px;

  .grid-item {
    &-component {
      overflow: hidden;
      box-sizing: border-box;
    }

    &--card {
      width: @grid-item-card-width;

      .grid-item-cover {
        height: @grid-item-card-cover-height;
      }

      .grid-item-title {
        margin-top: @size-extra-small;
      }
    }
    &--small {
      width: @grid-item-small-width;

      .grid-item-cover {
        height: @grid-item-small-cover-height;
      }

      .grid-item-bottom {
        padding: 0 @size-extra-small / 2;
      }

      .grid-item-title {
        margin-top: @size-extra-small;
        font-size: @font-size-base;
      }
    }
    &--large {
      width: @grid-item-large-width;

      .grid-item-cover {
        height: @grid-item-large-cover-height;
      }

      .grid-item-bottom {
        padding: 0 @size-extra-small;
      }

      .grid-item-title {
        margin-top: @size-small;
      }
    }
    &--full {
      width: @grid-item-full-width;

      .grid-item-cover {
        height: @grid-item-full-cover-height;
      }

      .grid-item-bottom {
        padding: 0 @size-extra-small;
      }

      .grid-item-title {
        margin-top: @size-small;
      }
    }

    &-cover-container {
      position: relative;
    }

    &-cover {
      display: block;
      width: 100%;
      border: @border-base;
      box-sizing: border-box;
      background-color: @background-color-base;
    }

    &-bottom {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: flex-end;
    }

    &-info {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &-title {
      margin: 0;
      line-height: 1.4;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;

      .list-item-vip-icon {
        display: inline-block;
        margin-right: 14px;
        width: 50px;
        height: 30px;
        vertical-align: -0.12em;
        background: url('~@/assets/img/vip/product_list_vip_icon.png');
        background-size: contain;
      }
    }

    &-summary {
      margin: @size-extra-small 0 @size-small 0;
      font-size: @font-size-small;
      color: @color-text-lighter;
    }
  }
</style>
